"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorBoundary = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
class ErrorBoundary extends react_1.default.Component {
    state = { hasError: false };
    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }
    componentDidCatch(error, errorInfo) {
        console.error('ErrorBoundary caught:', error, errorInfo);
        // Aquí puedes enviar el error a un servicio como Sentry
    }
    render() {
        if (this.state.hasError) {
            const { fallback } = this.props;
            const { error } = this.state;
            if (typeof fallback === 'function') {
                return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: fallback(error) });
            }
            return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: fallback || ((0, jsx_runtime_1.jsxs)("div", { className: "error-fallback", children: [(0, jsx_runtime_1.jsx)("h2", { children: "Something went wrong" }), error && (0, jsx_runtime_1.jsx)("p", { children: error.message }), (0, jsx_runtime_1.jsx)("button", { onClick: () => window.location.reload(), children: "Reload Page" })] })) }));
        }
        return this.props.children;
    }
}
exports.ErrorBoundary = ErrorBoundary;
